import React from "react";
import classnames from "classnames";
import ChangeIcon from "./svg/ChangeIcon";
import InputColor from ".";

export default function Gradient({
  value,
  value2,
  onChange,
  onChange2,
  maxWidth,
  className,
  reverseColors,
}) {
  return (
    <div
      className={classnames("d-flex", {
        [className]: className,
      })}
      style={maxWidth ? { maxWidth: `${maxWidth}px` } : {}}
    >
      <InputColor value={value} onChange={onChange} className="mb-0" />
      <div
        className="d-flex justify-content-center align-items-center px-3 border-bottom border-top cursor-pointer"
        onClick={reverseColors}
      >
        <ChangeIcon />
      </div>
      <InputColor value={value2} onChange={onChange2} className="mb-0" />
    </div>
  );
}
